import WordpressApi, { Menus } from "../../services/wordpressApi";
import Composer from "./index";
export default Composer;

export async function getServerSideProps({ params: { slug } }: any) {
  let data: any;
  let menus = {};
  let faqList = [];
  let faqCategory = [];
  let htmlHeader = "";
  try {
    [data, menus, faqCategory, faqList] = await Promise.all([
      WordpressApi.getPage(
        "sprachschule-faq-deutschsprachkursesprachpruefungen"
      ),
      WordpressApi.getMenus(),
      WordpressApi.getFAQCategory(),
      WordpressApi.getFAQ(slug),
    ]);
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }

  return {
    props: {
      data: data && data.blocks ? data.blocks : [],
      tags: data && data.tags ? data.tags : [],
      breadcrumbs: data && data.breadcrumbs ? data.breadcrumbs : [],
      header: data?.header || "",
      htmlHead: data && data.htmlHead ? data.htmlHead : "",
      menus,
      faqCategory,
      faqList,
    },
  };
}
